// Fix this file, do not use any as the type
/* eslint-disable no-param-reassign */
/* eslint-disable space-before-function-paren */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'

import { removeTokenCookies, getTokenCookies, removeCookies } from 'config/cookies'
import { axiosErrorLoggerInterceptor } from 'config/axiosLogger'
import { generateXDeviceId, getRequestXDevice } from 'utils/helpers/userAgent'

export const requestInterceptors = () => {
  axios.interceptors.request.use(
    async (config: any) => {
      const credentials = getTokenCookies()

      config.headers.Authorization = `Bearer ${credentials}`
      config.headers['Access-Control-Allow-Origin'] = 'http://localhost:3000'
      config.headers['Access-Control-Max-Age'] = 7200
      config.headers['x-device'] = getRequestXDevice()
      config.headers['x-device-id'] = await generateXDeviceId()

      return config
    },
    (error: any) => {
      if (error?.request?.status === 401) {
        removeTokenCookies()
        window.location.href = '/'
      }
      return Promise.reject(error)
    },
  )
}

export const responseInterceptors = () => {
  axios.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      axiosErrorLoggerInterceptor(error)

      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (error?.response?.status === 401) {
        if (window.location.pathname !== '/') {
          removeCookies('auth')
          window.location.href = '/'
        }
      }
      if (error?.response?.status === 403) {
        const nextError = {
          ...error,
          response: {
            ...error.response,
            data: {
              ...error.response.data,
              error_message: 'Anda tidak memiliki akses',
            },
          },
        }
        return Promise.reject(nextError)
      }

      return Promise.reject(error)
    },
  )
}
